// @ts-nocheck

export type OwnerGetWithProperties = typeof OwnerGetWithProperties[keyof typeof OwnerGetWithProperties];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerGetWithProperties = {
  true: 'true',
  false: 'false',
} as const;
